import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_6yzfk84dca: FaireBrandEntity = {
  token: "b_6yzfk84dca",
  type: "brand",
  name: "Yami",
  avatarUrl:
    "https://cdn.faire.com/fastly/0af59146199e75d742ad51024a36edf4705efcd67899e7bc8cc5e40bb0297535.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/c342e2c680780bf776da2c30bbd3b1251c2d13fa00b3b60182a1313273a45d4b.png",
  logoUrl:
    "https://cdn.faire.com/fastly/0af59146199e75d742ad51024a36edf4705efcd67899e7bc8cc5e40bb0297535.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/c342e2c680780bf776da2c30bbd3b1251c2d13fa00b3b60182a1313273a45d4b.png",
  location: "Brea, CA, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 5,
  isInsider: true,
  description:
    "Yami began in 2013 with a single, simple goal: make the flavors and rituals we grew up with as Asian Americans easy for everyone to enjoy. From that first shipment of ramen and matcha, we’ve grown into the leading U.S. platform for Asian food, beverage, beauty, and home goods—serving 3 million customers, shipping 50 million+ items, and earning a 4.9-star average review along the way. But we’re more than an online success story. We’re cultural curators. Our team of tastemakers scouts family-owned factories, cult-favorite K-beauty labs, and regional tea estates to hand-pick authentic SKUs you won’t find at big-box chains. Every product is lab-tested for U.S. compliance, thoughtfully packaged for shelf appeal, and backed by data on velocity and margin from our direct-to-consumer storefront.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:52:25.982Z",
    importedBy: "entity-db-cli",
  },
};
